import React from 'react';
import { GenericCheckbox } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const BusinessType = ({ values, setSelectedProducts }) => (
  <Content>
    {({
      additionalProductsInterestedId1Label = '',
      additionalProductsInterestedId2Label = '',
      additionalProductsInterestedId3Label = '',
      additionalProductsInterestedId4Label = '',
      additionalProductsInterestedId2Value = '',
      additionalProductsInterestedId1Value = '',
      additionalProductsInterestedId3Value = '',
      additionalProductsInterestedId4Value = ''
    }) => (
      <Field name="additionalProductsInterestedField" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <div>
            <Field name="additionalProductsInterestedField" type="checkbox">
              {({ input }) => (
                <GenericCheckbox.StackedSet
                  items={[
                    {
                      id: additionalProductsInterestedId4Value,
                      labelText: additionalProductsInterestedId4Label
                    },
                    {
                      id: additionalProductsInterestedId2Value,
                      labelText: additionalProductsInterestedId2Label
                    },
                    {
                      id: additionalProductsInterestedId3Value,
                      labelText: additionalProductsInterestedId3Label
                    },
                    {
                      id: additionalProductsInterestedId1Value,
                      labelText: additionalProductsInterestedId1Label
                    }
                  ]}
                  groupName="additionalProductsInterestedField"
                  onChange={selectedIds => setSelectedProducts(selectedIds)}
                  selectedIds={values}
                />
              )}
            </Field>
          </div>
        )}
      </Field>
    )}
  </Content>
);

export default BusinessType;
